import {createEntityService} from 'utils/createEntityService';
import {BillingRule} from 'types/billingRule';

export const BillingRulesService = createEntityService<BillingRule>({
  baseUrl: 'api/v1/billing_rules',
  entityName: 'billingRule',
});
